exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#http-loader {\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: fixed;\n    z-index: 9999;\n}\n\n.loader-bg {\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    filter: alpha(opacity=70);\n    opacity: .7;\n    background-color: #f1f1f1;\n}\n\n.colored-parent, .colored > div {\n    background-color: #333;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/app/shared/spinner/spinner.component.css
// module id = ../../../../../src/app/shared/spinner/spinner.component.css
// module chunks = main